import { HAS_WINDOW } from './has-window';
/**
 * Safely gets a property from the window object
 * @param {string} key property on window to retrieve
 */
export function getWindowObject(key) {
    return HAS_WINDOW && window[key];
}
